import {Table} from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`
    @media screen and (max-width: 768px) {
        .ant-table {
            overflow-x: visible;
            width: 100%;
            max-width: 100%;
        }

        .ant-table table {
            min-width: 100%;
            width: 100%;
            max-width: 100%;
            table-layout: auto;
        }

        .ant-table-thead > tr > th {
            display: none !important;
        }

        .ant-table table th {
            display: none !important;
        }

        .ant-table table td {
            display: flex !important;
            justify-content: space-between;
            align-items: center;
            padding: 14px 16px !important;
            border-bottom: 1px solid #f0f0f0;
            font-size: 14px;
            min-height: 48px;
            width: 100%;
            box-sizing: border-box;
            gap: 12px;
        }

        .ant-table table td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #333;
            text-align: left;
            flex-shrink: 0;
            font-size: 14px;
            min-width: 120px;
            max-width: 120px;
            display: block;
            line-height: 1.5;
        }

        .ant-table table td[data-label=""]::before,
        .ant-table table td:not([data-label])::before {
            display: none;
        }

        .ant-table table td > * {
            text-align: right;
            flex: 1;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: normal;
            white-space: normal;
            line-height: 1.5;
            min-width: 0;
            display: flex;
            justify-content: flex-end;
        }

        .ant-table table tbody tr {
            display: block;
            margin-bottom: 20px;
            background: white;
            border-radius: 12px;
            border: 1px solid #e8e8e8;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td {
            display: flex !important;
            border-bottom: 1px solid #f5f5f5;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td:first-child {
            padding-top: 16px !important;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
        }

        .ant-table table tbody tr td:last-child {
            padding-bottom: 16px !important;
            border-bottom: none;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        .ant-table-tbody > tr:hover > td {
            background: #fafafa;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-table table td {
            font-size: 13px;
            padding: 12px 14px !important;
            gap: 10px;
        }

        .ant-table table td::before {
            font-size: 13px;
            min-width: 100px;
            max-width: 100px;
            text-align: left;
        }

        .ant-table table td > * {
            text-align: right;
        }
    }
`;

